<template>
    <div class="d-flex flex-column">
        <div class="d-flex text-nowrap">
            <span><b-icon icon="circle-fill" :variant="variant" class="mr-1"/></span>
            <span>{{ statusName }}</span>
        </div>
        <div>
            <small class="text-secondary">{{ extraValue }}</small>
        </div>
    </div>
</template>

<script>
    import { NewsStatus, NEWS_STATUS } from "@/pages/AppPages/News/news";

    export default {
        name: "NewsStatusCell",
        props: {
            value: { },
            extraValue: {},
        },
        computed: {
            statusName() {
                return NEWS_STATUS[this.value]
            },
            variant() {
                switch (this.value) {
                    case NewsStatus.DRAFT: return 'warning';
                    case NewsStatus.READY_FOR_MODERATION: return 'info';
                    case NewsStatus.MODERATED: return 'primary';
                    case NewsStatus.PUBLISHED: return 'success';
                    case NewsStatus.DECLINED: return 'danger';
                    default: return 'secondary'
                }
            }
        }
    }
</script>

<style scoped>

</style>